import React, { FC } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { LeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { ButtonProps } from 'antd/lib/button';
import styled from 'styled-components';
import { useDirection } from '~/hooks';

const BackButton: FC<ButtonProps> = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [dir] = useDirection();

  const goBack = () => {
    history.goBack();
  };

  return (
    <StyledButton type="link" icon={<LeftOutlined />} onClick={goBack} dir={dir} {...props}>
      {t('back')}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  transform: ${({ dir }) => (dir === 'rtl' ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export default BackButton;
